import React, { useState, useEffect } from "react";
import styles from "../PD/pd.module.css";
import Cookies from "js-cookie";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { TbFileUpload } from "react-icons/tb";
import Tooltip from '@mui/material/Tooltip';
import "../VCIP.css"

const VideoPD = () => {
  const [open, setOpen] = React.useState(false);
  const { loanid } = useParams();
  const { borrowerData } = useBorrowerContext();
  const [userName, setUserName] = useState("");
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [openModal, setOpenModal] = useState(false);
  const [borrowerId, setBorrowerID] = useState("");
  const [loanId, setLoanId] = useState("");
  const [file, setFile] = useState(null);
  const [visible, setvisible] = useState(false);
  const [UploadVideoVisible, setUploadVideoVisible] = useState(false);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          console.log(res, "response");
          setUserName(res.data[0].staff_name);
          setUploadVideoVisible(res.data[0].permission.upload_video);
        })
        .catch((err) => {
          console.log(err);
        })
    };
  }, [email, token]);

  const firstName = borrowerData?.borrower?.borrower_firstname?.trim() || "Customer";
  const lastName = borrowerData?.borrower?.borrower_lastname?.trim() || "Customer";
  const name = `${firstName}-${lastName}`;
  const formattedUserName = userName.replace(/\s+/g, "-");

  const initiatePD = () => {
    sessionStorage.setItem("LoanID", loanid);
    sessionStorage.setItem("fullName", name);
    sessionStorage.setItem("formattedUserName", formattedUserName);
    window.open('/vpd', "_blank");
  };

  const handleVideoRecording = async () => {
    setOpen(true);
    const formData = new FormData();
    formData.append("loan_Id", loanId);
    formData.append("borrower_Id", borrowerId);
    formData.append("file", file);

    try {
      const res = await axios.post(url + "/videosdk/upload/video", formData);

      if (res.data.auth === true) {
        toast.success(res.data.message);
        setBorrowerID("");
        setLoanId("");
        setFile(null);
        setOpenModal(false);
      } else {
        toast.error(res.data.message);
      }

    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <div className={styles.loanSelect}>
        <button onClick={initiatePD} className={styles.pdButton}>
          Initiate PD
        </button>
        {(UploadVideoVisible || visible) && (
          <Tooltip title="Upload Video Recording">
            <div>
              <TbFileUpload
                size={30}
                style={{ cursor: "pointer" }}
                onClick={() => setOpenModal(true)}
              />
            </div>
          </Tooltip>
        )}
      </div>

      <hr className={styles.hr} />
      {openModal && (
        <div className="modal-overlay-vcip">
          <div className="modal-content-vcip">
            <h2>Upload Video Recording</h2>
            <div className="form-group-vcip">
              <label>Borrower ID</label>
              <input
                type="text"
                value={borrowerId}
                onChange={(e) => setBorrowerID(e.target.value)}
                placeholder="Enter Borrower ID"
              />
            </div>

            <div className="form-group-vcip">
              <label>Loan ID</label>
              <input
                type="text"
                value={loanId}
                onChange={(e) => setLoanId(e.target.value)}
                placeholder="Enter Loan ID"
              />
            </div>

            <div className="form-group-vcip">
              <label>Upload Video</label>
              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>

            <div className="modal-actions-vcip">
              <button
                className="btn-save-vcip"
                onClick={handleVideoRecording}
                disabled={!borrowerId || !file || !loanId}
              >
                Submit
              </button>
              <button
                className="btn-cancel-vcip"
                onClick={() => {
                  setBorrowerID("");
                  setLoanId("");
                  setFile(null);
                  setOpenModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default VideoPD;
